import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = (state) => get(state, SCOPE);

export const loadingSelector = createSelector(selector, (store) => store.isFetching);

export const selectedAlertSelector = createSelector(selector, (store) => store.selectedAlert);

export const alertDiagnosticsSelector = createSelector(
  selector,
  (store) => store.selectedAiAlertDiagnostics,
);

export default selector;
